// Define the stages of processing
export const getInitialStages = (sourceType: string): Stages => {
  return {
    ...(sourceType === 'upload'
      ? {
          UPLOAD: {
            id: 'UPLOAD',
            name: 'Uploading file to secure storage',
            status: 'IN_PROGRESS',
          },
          TEXTRACT_CONVERT: {
            id: 'TEXTRACT_CONVERT',
            name: 'Converting document to text',
            status: 'PENDING',
          },
          TEXTRACT_RECEIVE: {
            id: 'TEXTRACT_RECEIVE',
            name: 'Receiving converted results',
            status: 'PENDING',
          },
          CLEANUP: {
            id: 'CLEANUP',
            name: 'Deleting your file from temporary storage',
            status: 'PENDING',
          },
        }
      : {}),
    COMPREHEND: {
      id: 'COMPREHEND',
      name: 'Extracting medical data',
      status: sourceType === 'text' ? 'IN_PROGRESS' : 'PENDING',
    },
    ENTITIES_MATCHING: {
      id: 'ENTITIES_MATCHING',
      name: 'Matching entities to patient parameters',
      status: 'PENDING',
    },
    ADDITIONAL_INFO: {
      id: 'ADDITIONAL_INFO',
      name: 'Extracting additional information',
      status: 'PENDING',
    },
  };
};

export interface Stages {
  [key: string]: StageUpdate;
}

export interface StageUpdate {
  id: string;
  name?: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETE' | 'FAILED' | 'SKIPPED';
  message?: string;
  isFinal?: boolean;
  data?: any; // Final data on completion
  error?: string; // Error message on failure
  debugData?: any; // Raw data for debugging on specific stages
}

export type SendUpdateCallback = (update: StageUpdate) => void;

// Interface for extracted medical entities
export interface MedicalEntity {
  id: string;
  text: string;
  category: string;
  type: string;
  score: number;
  begin: number;
  end: number;
  attributes?: any[];
  traits?: any[];
  icd10Code?: string;
  icd10Description?: string;
}

// Interface for processed entities grouped by category
export interface ProcessedEntities {
  conditions: MedicalEntity[];
  medications: MedicalEntity[];
  tests: MedicalEntity[];
  procedures: MedicalEntity[];
  anatomy: MedicalEntity[];
  demographics: MedicalEntity[];
  otherInformation: MedicalEntity[];
}

// Interface for patient parameter matches
export interface PatientParameterMatch {
  cancerType?: string;
  cancerTypeId?: string;
  cancerSubtype?: string;
  cancerSubtypeId?: string;
  gender?: string;
  genderId?: string;
  age?: string;
  ageId?: string;
  matchedConditions?: any[];
  additionalInfo?: string;
}

// Interface for the final extracted medical data
export interface ExtractedMedicalData {
  documentId: string;
  fileName: string;
  processedDate: string;
  rawText?: string;
  entities: ProcessedEntities;
  patientParameters?: PatientParameterMatch;
}
